const Phone = {
  display: (phoneNumber: string) => {
    if (!phoneNumber) {
      return '';
    } else {
      return (
        `(${phoneNumber.substring(0, 3)})` +
        ` ` +
        `${phoneNumber.substring(3, 6)}` +
        `-` +
        `${phoneNumber.substring(6, 10)}` +
        `${phoneNumber.substring(10)}`
      );
    }
  },

  createUrl: (phoneNumber: string) => {
    return `tel:${phoneNumber}`;
  },

  strip: (phoneNumber: string) => {
    if (!phoneNumber) {
      return '';
    }
    return phoneNumber.replace(/\D/g, '');
  },
};

export default Phone;
